var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "search_svg__icon--search",
    viewBox: "0 0 43 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m29.706 27.82 9.054 9.054a1.291 1.291 0 0 1-1.8 1.852l-9.054-9.054a1.291 1.291 0 0 1 1.8-1.851zM17.208 2.959c7.6 0 13.76 6.161 13.76 13.76s-6.16 13.76-13.76 13.76-13.76-6.16-13.76-13.76 6.16-13.76 13.76-13.76m0 2.535c-6.2 0-11.225 5.026-11.225 11.225 0 6.2 5.026 11.226 11.225 11.226 6.2 0 11.225-5.026 11.225-11.226 0-6.199-5.025-11.225-11.225-11.225"
  })));
};
export default SvgSearch;